import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    position: "fixed",
    zIndex: 999,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  content: {
    inset: "50% auto auto 50%",
    transform: "translate(-50%, -50%)",
    padding: 0,
    border: "none",
    background: "transparent",
  },
};

Modal.setAppElement("#root");

const ImageSwiper = ({ isOpen, data = [], onClose }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const handlePrev = () => {
    setActiveIndex((prev) =>
      prev === 0 ? data.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prev) =>
      prev === data.length - 1 ? 0 : prev + 1
    );
  };

  // Swipe handlers
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;

    if (diff > 50) handleNext();
    if (diff < -50) handlePrev();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Image Swiper"
      ariaHideApp={false}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">

          {/* BODY */}
          <div
            className="modal-body text-center"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {data.length > 0 && (
              <img
                src={data[activeIndex]?.uri}
                alt={`Slide ${activeIndex}`}
                className="img-fluid"
                style={{ maxHeight: "70vh", objectFit: "contain" }}
              />
            )}

            {/* Indicators */}
            <div className="mt-3 d-flex justify-content-center gap-2">
              {data.map((_, i) => (
                <span
                  key={i}
                  onClick={() => setActiveIndex(i)}
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    cursor: "pointer",
                    background: i === activeIndex ? "#000" : "#ccc",
                  }}
                />
              ))}
            </div>
          </div>

          <button
            className="btn btn-light position-absolute top-50 start-0 translate-middle-y"
            onClick={handlePrev}
          >
            ‹
          </button>

          <button
            className="btn btn-light position-absolute top-50 end-0 translate-middle-y"
            onClick={handleNext}
          >
            ›
          </button>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>

        </div>
      </div>
    </Modal>
  );
};

export default ImageSwiper;